(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ugc-gallery').forEach(function (section) {
    if (section.dataset.ugcGalleryInit) return;
    section.dataset.ugcGalleryInit = 'true';

    const track = section.querySelector('.ugc-gallery__track');
    const dotsWrapper = section.querySelector('.ugc-gallery__dots');
    const prevBtn = section.querySelector('.ugc-gallery__arrow--prev');
    const nextBtn = section.querySelector('.ugc-gallery__arrow--next');
    const items = section.querySelectorAll('.ugc-gallery__item');

    if (!track || !items.length) return;

    function visibleCount() {
      if (window.innerWidth <= 749) return 2;
      if (window.innerWidth <= 989) return 3;
      return 4;
    }

    function totalPages() {
      return Math.ceil(items.length / visibleCount());
    }

    function buildDots() {
      dotsWrapper.innerHTML = '';
      const count = totalPages();
      for (let i = 0; i < count; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.classList.add('ugc-gallery__dot');
        if (i === 0) dot.classList.add('ugc-gallery__dot--active');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', () => goToPage(i));
        dotsWrapper.appendChild(dot);
      }
    }

    function goToPage(index) {
      const targetItem = items[index * visibleCount()];
      if (!targetItem) return;
      track.scrollTo({ left: targetItem.offsetLeft, behavior: 'smooth' });
    }

    function currentPage() {
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const itemWidth = items[0].offsetWidth + gap;
      return Math.round(track.scrollLeft / (itemWidth * visibleCount()));
    }

    function updateDots() {
      const page = currentPage();
      section.querySelectorAll('.ugc-gallery__dot').forEach((dot, i) => {
        dot.classList.toggle('ugc-gallery__dot--active', i === page);
      });
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 2;
    }

    prevBtn.addEventListener('click', () => goToPage(Math.max(0, currentPage() - 1)));
    nextBtn.addEventListener('click', () => goToPage(Math.min(totalPages() - 1, currentPage() + 1)));

    let scrollTimeout;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        updateDots();
        updateArrows();
      }, 50);
    });

    window.addEventListener('resize', () => {
      buildDots();
      updateArrows();
    });

    buildDots();
    updateArrows();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.usp-bar').forEach(function (section) {
    if (section.dataset.uspBarInit) return;
    section.dataset.uspBarInit = 'true';

    const list = section.querySelector('.usp-bar__list');
    const dots = section.querySelectorAll('.usp-bar__dot');
    const items = section.querySelectorAll('.usp-bar__item');
    let currentIndex = 0;
    let autoplayTimer;

    function updateDots() {
      dots.forEach((dot, index) => {
        dot.classList.toggle('usp-bar__dot--active', index === currentIndex);
      });
    }

    function goToSlide(index) {
      currentIndex = index;
      list.scrollTo({ left: list.offsetWidth * index, behavior: 'smooth' });
      updateDots();
    }

    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = setInterval(() => {
        goToSlide((currentIndex + 1) % items.length);
      }, 3000);
    }

    function stopAutoplay() {
      clearInterval(autoplayTimer);
    }

    if (window.matchMedia('(max-width: 749px)').matches && items.length > 1) {
      startAutoplay();
    }

    list.addEventListener('scroll', () => {
      currentIndex = Math.round(list.scrollLeft / list.offsetWidth);
      updateDots();
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        stopAutoplay();
        goToSlide(index);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
